<template>
	<li class="key-value-item">
		<p class="key-value-item__label">{{ label }}</p>
		<p v-if="value.constructor === Array" class="key-value-item__value">
			<span v-for="line in value" :key="uuidv(line)">
				{{line}} <br/>
			</span>
		</p>
		<p v-else-if="value" class="key-value-item__value">{{ value }}</p>
		<p v-else class="key-value-item__value">
			<slot>

			</slot>
		</p>
	</li>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default{
	name: 'key-value-item',
	props: {
		label: String,
		value: {
			type: [String, Number, Array],
			default: null
		}
	},
	methods: {
		uuid(){
			return uuidv4();
		}
	}
}
</script>

<style scoped>
.key-value-item{
	font-size: 15px;
	display:flex;
	justify-content:space-between;
	border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
	padding:0;
	margin:0;
	line-height: 1.5;
}
.key-value-item p{
	padding:0;
	margin-top: 5px;
	margin-bottom: 5px;
}
.key-value-item__label{
	font-weight: bold;
	margin-right:20px;
}
.key-value-item__value{
	text-align: right;
	word-wrap: break-word;
	overflow: auto;
}
</style>
